import { motion } from 'framer-motion';
import styled, { keyframes } from 'styled-components';

import { fadeTransition, FadeVariant, fadeVariants } from '@pkg/motion';
import { floorGameColor as color, floorGameDuration as duration, styledLayout, styledMedia } from '@pkg/primitives';

import { overlayBase, tokens } from '../../tokens';

const loadingShine = keyframes`
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
`;

export const StyledSkeleton = styled(motion.div).attrs({
    variants: fadeVariants,
    initial: FadeVariant.Hidden,
    animate: FadeVariant.Show,
    exit: FadeVariant.Hidden,
    transition: fadeTransition,
})`
    ${overlayBase};
    background: ${tokens.skeleton.gradient};

    &::before {
        ${styledLayout.positionCover()}
        content: '';
        background-color: rgba(255, 255, 255, 0.1);
        animation: ${loadingShine} ${duration.crawl}ms ease-in-out alternate infinite both;
    }
`;

export const IconWrapper = styled.div`
    ${styledMedia.iconWrapper}
    width: 100%;
    height: 100%;
    color: ${color.ash};

    // Required to combat v2-global-reset
    && svg {
        max-width: 60%;
    }
`;
